import { QueryClient } from 'react-query';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, keepPreviousData: true } },
});

export default queryClient;
